
import { Options, Vue } from 'vue-class-component';
import { teamService } from '@/services/team.service';
import { TeamMember } from '@/interfaces/team';
import TeamMemberCard from '@/components/TeamMemberCard.vue';
import { Subscription } from 'rxjs';

const VALID_TABS = ['leadership', 'tekken', 'bounty-hunters'];

@Options({
  components: {
    TeamMemberCard
  },
  watch: {
    '$route.params.tab'(newTab: string) {
      if (newTab && VALID_TABS.includes(newTab)) {
        this.activeTab = newTab;
      } else if (!newTab) {
        this.activeTab = 'leadership';
      }
    }
  }
})
export default class TeamView extends Vue {
  activeTab = 'leadership';
  leadership: TeamMember[] = [];
  tekkenEsports: TeamMember[] = [];
  bountyHunters: TeamMember[] = [];

  private leadershipSub: Subscription | null = null;
  private tekkenEsportsSub: Subscription | null = null;
  private bountyHuntersSub: Subscription | null = null;

  async mounted() {
    // Set initial tab from URL
    const tabParam = this.$route.params.tab as string;
    if (tabParam && VALID_TABS.includes(tabParam)) {
      this.activeTab = tabParam;
    }

    this.leadershipSub = teamService.getLeadership().subscribe(data => {
      this.leadership = data;
    });
    this.tekkenEsportsSub = teamService.getTekkenEsports().subscribe(data => {
      this.tekkenEsports = data;
    });
    this.bountyHuntersSub = teamService.getBountyHunters().subscribe(data => {
      this.bountyHunters = data;
    });

    await Promise.all([
      teamService.fetchLeadership(),
      teamService.fetchTekkenEsports(),
      teamService.fetchBountyHunters()
    ]);
  }

  onTabChange(tab: string) {
    this.$router.replace({ name: 'team', params: { tab } });
  }

  unmounted() {
    this.leadershipSub?.unsubscribe();
    this.tekkenEsportsSub?.unsubscribe();
    this.bountyHuntersSub?.unsubscribe();
  }
}
